'use strict'
export default class Commentscostumer {
    constructor(
        namecomplete = "",
        email = "",
        comments = ""
    ) {
        this.namecomplete = namecomplete
        this.email = email
        this.comments = comments
    }

}